import { createOpenStore, type ColumnDialogOpen } from "stores/createOpenStore";

/** The wizard's own state lives in WASM (`CoreClientApp.wizard`). */
export const useReferenceMatchingStore = createOpenStore<ColumnDialogOpen>();
